import { z } from 'zod'

import { applicationAccountUserModel } from '@/common/models/applicationAccountUser'

export const applicationAccountUserSubject = z.tuple([
  z.literal('create'),
  z.union([z.literal('ApplicationAccountUser'), applicationAccountUserModel]),
])

export type ApplicationAccountUserSubject = z.infer<
  typeof applicationAccountUserSubject
>
